import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  size: 'small' | 'medium' | 'large';
};

export const Illustration = styled.img<Props>(
  ({size}) => css`
    width: 100%;
    max-width: ${{
      small: '54px',
      medium: '91px',
      large: '102px',
    }[size]};
  `
);
